import React from "react";
import EACheckbox from "../../EACheckbox";
import {Box} from "@material-ui/core";

function ConsentDeclarationComponent({handleDsgvoChanged, errors, ...rest}) {
    return (
        <div>
            <p><b>Einwilligungserklärung in die Erhebung und Verarbeitung von Daten</b><br/><b>für die
                Fachanwendungen der Wasserwirtschaftsverwaltung in Rheinland-Pfalz</b></p>

            <p>Im Folgenden klären wir über die Verwendung personenbezogener Daten registrierter Anwender in
                einer wasserwirtschaftlichen Fachanwendung auf. Die vollständige Datenschutzerklärung finden
                Sie
                auf dieser Webseite unter <a href="/"
                                             target="_blank">Datenschutzerklärung</a>.
            </p><p>Für diese Fachanwendung werden von registrierten Anwendern die folgenden
            personenbezogenen
            Daten erhoben und verarbeitet:</p>
            <ul className="default">
                <li>Vor -und Nachname, postalische Adresse, Funktion</li>
                <li>Telefonnummer, E-Mail-Adresse</li>
                <li>institutionelle Zuordnung, zum Beispiel zu Verwaltungseinheit, Maßnahmeträger,
                    Abgabe-oder
                    Entgeltpflichtiger
                </li>
            </ul>

            <p>Die Daten werden auf den Servern der Wasserwirtschaftsverwaltung Rheinland-Pfalz gespeichert
                und
                können nur von berechtigten Personen eingesehen werden. Der Umfang der zum Anwender
                gespeicherten Daten kann von diesem jederzeit eingesehen und korrigiert werden.</p>
            <p>Die in diesem Zusammenhang durchgeführte elektronische Verarbeitung der genannten Daten
                erfolgt
                auf der Grundlage geltender Gesetze und ist für den sachgerechten Betrieb der Fachanwendung
                notwendig. </p>
            <p>Durch Zustimmung zu dieser Einwilligungserklärung erklärt sich der Anwender mit der Erhebung,
                Speicherung und Verarbeitung dieser Daten im Zusammenhang mit dem Betrieb der Fachanwendung
                einverstanden. </p>
            <p>Der Anwender hat das Recht, dieser Einwilligungserklärung nicht zuzustimmen oder diese
                Einwilligung jederzeit ohne Angabe einer Begründung zu widerrufen und die gespeicherten
                Daten
                löschen zu lassen. Da die Fachanwendung jedoch auf die Erhebung und Verarbeitung genannter
                Daten
                angewiesen ist, würde dies eine Inanspruchnahme der Fachanwendung ausschließen.</p>
            <p>Anfragen und andere Anliegen in diesem Zusammenhang sind per E-Mail an <a
                href="mailto:datascout@wwv.rlp.de">datascout@wwv.rlp.de</a> zu richten.</p>

            <Box mt={2}>
                <EACheckbox
                    id="Einwilligungserklärung"
                    error={errors.dsgvo}
                    required
                    onChange={(e, newValue) => handleDsgvoChanged(newValue)}
                    {...rest}
                >
                    *Ich habe die <strong>Einwilligungserklärung</strong> gelesen und erkläre mich damit einverstanden.
                </EACheckbox>
            </Box>
        </div>
    )
}

export default ConsentDeclarationComponent;
